export const uk = {
    'inconsistent-ad-group-type-to-campaign-type': 'Тип создаваемой группы не соответствует типу кампании',
    'max-adgroups-in-campaign': 'Достигнут максимум групп в кампании',
    'name-prohibited-symbols': 'Название группы содержит запрещенные символы'
};
